export class ActionCannotBeStartedError extends Error {
  constructor() {
    super('Action cannot be started.');
  }
}
